import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, RouterOutlet } from '@angular/router';
import { CompanyParamsService } from 'src/app/core/services/company-params.service';
import { HeaderComponent } from '../../../core/components/header/header.component';
import { NgStyle } from '@angular/common';
import { FooterComponent } from '../../../core/components/footer/footer.component';
import { WhastappButtonComponent } from '../../../core/components/whastapp-button/whastapp-button.component';

@Component({
    selector: 'app-main-layout',
    templateUrl: './main-layout.component.html',
    styleUrls: ['./main-layout.component.scss'],
    imports: [HeaderComponent, NgStyle, RouterOutlet, FooterComponent, WhastappButtonComponent]
})
export class MainLayoutComponent implements OnInit {

  padding:any;
  headerHeightInput:any;
  headerHeightInput1:any;
  linkLocation: string = '';
  renderHeaderFooter: boolean = true;

  constructor(
    public companyParamsService: CompanyParamsService,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.padding = this.headerHeightInput;
  }

  getHeight(height:any){
    this.headerHeightInput = height;
  }

  getHeight1(height:any){
    this.headerHeightInput1 = height;
  }

  ngAfterViewInit() {
    setTimeout(() =>{
      if (typeof localStorage === 'undefined') return;
      this.padding = this.headerHeightInput - 77;
      localStorage.setItem('height-'+this.companyParamsService.getCode(),this.headerHeightInput);
      localStorage.setItem('height1-'+this.companyParamsService.getCode(),this.headerHeightInput1);
    },900);
  }
}
